<style lang="scss" scoped>
.count {
    background-image: url(./../../assets/approved.png) ;
    padding-top: 12px;
    padding-left: 38px;
    background-size: contain;
    width: 94px;
    height: 85px;
    color: white;
    font-style: italic;
    &.small {
        padding-top: 0px;
        padding-left: 18px;
        height: 48px;
        width: 56px;
        font-size: 12px;
    }
}

.shake {
  /* Запустите анимацию встряхивания и сделайте так, чтобы анимация длилась 0,5 секунды */
  animation: shake 0.5s;

  /* Когда анимация будет закончена, начните снова */
//   animation-iteration-count: infinite;
}

@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

</style>

<template>
    <div 
        @click="$emit('click')"
        :class="{small: small, shake: shake}"
        class="count text-center"
        >                
        {{ count }}
    </div>
</template>

<script>
export default {
    props: {
        value: [Number,String], 
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        count() {
            return this.value
        }
    },
    data: () => ({
        shake: false,
    }),
    watch: {
        count() {
            this.shake = true;

            setTimeout(
                () => this.shake = false,
                500
            )
        }
    }
}
</script>